import { render, staticRenderFns } from "./ReadedBoxes.vue?vue&type=template&id=4f857209&scoped=true&"
import script from "./ReadedBoxes.vue?vue&type=script&lang=js&"
export * from "./ReadedBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ReadedBoxes.vue?vue&type=style&index=0&id=4f857209&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f857209",
  null
  
)

export default component.exports